import { useMemo } from "react";

import usePaginatedResources from "hooks/usePaginatedResources";
import { usePaginatedVariables } from "hooks/strings/usePaginatedVariables";
import useGetEmployees from "./useGetEmployees";
import ArchivedActionsCell from "modules/OrganizationEmployees/ArchivedActionsCell";
import formatCentsToUSD from "utils/money/formatCentsToUSD";
import { sortDirectionMap } from "constants/sortDirectionMap";

export default function useArchivedEmployeesTable() {
  const { filtering, offset, sorting } = usePaginatedVariables();
  const { data, loading, error, paginatorInfo, fetchMore } = useGetEmployees({
    page: offset.page,
    first: offset.first,
    search: filtering.debouncedSearchTerm,
    sort: sortDirectionMap[sorting.sortDirection],
    archived: true,
  });
  const pagination = usePaginatedResources({
    paginate: offset.paginate,
    paginatorInfo,
  });

  const columns = useMemo(() => {
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      { Header: "Rate", accessor: "rate", Cell: (props) => formatCentsToUSD(props.value) },
      {
        Header: "Archived On",
        accessor: "archivedAt",
        Cell: (props) => (props.value ? new Date(props.value).toLocaleDateString() : ""),
      },
      {
        Header: "Actions",
        accessor: "id",
        Cell: ArchivedActionsCell,
        align: "right",
      },
    ];
  }, []);

  const tableData = useMemo(() => {
    fetchMore({
      page: offset.page,
    });
    return { columns, rows: data };
  }, [columns, data]);

  return {
    data,
    loading,
    error,
    columns,
    tableData,
    pagination,
    paginatorInfo,
    filtering,
  } as const;
}
